<div class="w-full mx-auto">
  <div class="bg-white rounded-md overflow-hidden border border-gray-200">
    <!-- Table Header -->
    @if (headerText) {
    <div class="bg-gray-100 px-2 py-2 border-b border-gray-200">
      <h3 class="text-[14px] font-bold text-gray-700">{{ headerText }}</h3>
    </div>
    }

    <!-- Sub Heading -->
    @if (subHeading) {
    <div class="px-2 py-1 text-center border-b border-gray-200">
      <h4 class="text-[13px] font-semibold text-gray-500">{{ subHeading }}</h4>
    </div>
    }

    <!-- Table Content -->
    @for (row of pairedData(); track $index) {
    <div class="grid grid-cols-4 border-b border-gray-200 last:border-b-0">
      <!-- First Label-Value Pair -->
      <div class="px-2 py-1 border-r border-gray-200">
        <span class="text-[13px] font-medium text-gray-500">{{
          row.item1.label
        }}</span>
      </div>
      <div class="bg-white px-2 py-1 border-r border-gray-200">
        <span class="text-[13px] text-gray-900">{{
          row.item1.value || "-"
        }}</span>
      </div>

      <!-- Second Label-Value Pair -->
      @if (row.item2) {
      <div class="px-2 py-1 border-r border-gray-200">
        <span class="text-[13px] font-medium text-gray-500">{{
          row.item2.label
        }}</span>
      </div>
      <div class="bg-white px-2 py-1">
        <span class="text-[13px] text-gray-900">{{
          row.item2.value || "-"
        }}</span>
      </div>
      } @else {
      <!-- Empty cells if no second item -->
      <div class="px-2 py-0.5 border-r border-gray-200"></div>
      <div class="bg-white px-2 py-1"></div>
      }
    </div>
    }
  </div>
</div>
